module.exports = __webpack_public_path__ + "static/media/page-not-found.fd3f639b.png";